module.exports = __webpack_public_path__ + "assets/logo-black.9191511b.svg";